const host = window.location.host;
let clientId;
let authority;
let redirectUri;

switch (host){
  case 'localhost:3000':
    clientId = '94c396bd-2b02-4515-89a2-562200484368';
    authority = 'https://login.microsoftonline.com/638fcbaf-ba4c-43e1-adae-5475c970fe10';
    redirectUri = 'http://localhost:3000';
    break;
  default:
    clientId = '94c396bd-2b02-4515-89a2-562200484368'
    authority = 'https://login.microsoftonline.com/638fcbaf-ba4c-43e1-adae-5475c970fe10';
    redirectUri = 'https://' + host;
    break;
}

export const msalConfig = {
  auth: {
    redirectUri: redirectUri,
    clientId: clientId,
    authority: authority,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
}

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ['User.Read'],
  // scopes: ["User.ReadWrite"],
}
